export default {
	env:                   process.env.VUE_APP_ENV,
	config:                null,
	leadtime:              30,
	requiredSalesData: {
		siteId:              null,
		salesAreaId:         null,
		foodMenuId:          null,
		drinksMenuId:        null,
		serviceId:           null,
		tableNumber:         null
	},
	tables:                [],
	menus: {
		food: {
			display: {
				displayGroups:   []
			}
		},
		drinks: {
			display: {
				displayGroups:   []
			}
		}
	},
	location:              {},
	allLocations:          [],
	iOrderLocation:        {},
	basket: {
		lines:               [],
		voucherLines:        []
	},
	error:                 {},
	validVoucherApplied:   null,
	lineItemsAddedCount:   0
}
